import { render, staticRenderFns } from "./XySingleSelect.vue?vue&type=template&id=1173ef58&scoped=true&"
import script from "./XySingleSelect.vue?vue&type=script&lang=js&"
export * from "./XySingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./XySingleSelect.vue?vue&type=style&index=0&id=1173ef58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1173ef58",
  null
  
)

export default component.exports